export const plaqueContentStyleForTrait = (plaque, plaqueContentStyle = 0) => {
  if (plaque.type) {
    return {
      contents:
        plaque.type.contentOptions[plaqueContentStyle % plaque.type.contentOptions.length]
    }
  }
  return { contents: null }
}
